import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IHosting } from '@entities/hosting/IHosting';

interface IProps {
  id: number;
}

export const fetch = async ({ id }: IProps): Promise<IHosting> => {
  // const hosting = await api.get<any>(`${BI_BASE_URL}/clients/${id}`);

  return {
    id: 1,
    name: 'Mining Capital',
    status: 'Активен',
    common_power: 70,
    locations: ['Сосновоборск'],
    nominal_power: 17,
    actual_power: 17,
    percent_of_power: 21,
    free_power: 18,
  };
  // return hosting.data ?? [];
};

export const useHosting = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
